import React, { useEffect, useState } from 'react';
import { Container, Typography, GridLegacy as Grid, Paper } from '@mui/material';
import useUserApi from '../../api/useUserApi';

const AdminDashboard: React.FC = () => {
  const { listUsers } = useUserApi();
  const [stats, setStats] = useState({
    totalUsers: 0,
    generatedHoroscopes: 0,
    activeSessions: 0,
  });

  useEffect(() => {
    listUsers().then((users) => {
      setStats({
        totalUsers: users.length,
        generatedHoroscopes: 128,
        activeSessions: 5,
      });
    });
  }, [listUsers]);

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        לוח בקרה - מצב כולל
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">סה"כ משתמשים</Typography>
            <Typography variant="h4">{stats.totalUsers}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">מספר הורוסקופים שנוצרו</Typography>
            <Typography variant="h4">{stats.generatedHoroscopes}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">סשנים פעילים</Typography>
            <Typography variant="h4">{stats.activeSessions}</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AdminDashboard;
